import { Banco } from '@store/refinanciamento/dadosBancarios/types'

export const buildTipoEndereco = () => [
  {
    value: '1',
    text: 'Rua',
  },
  {
    value: '2',
    text: 'Avenida',
  },
  {
    value: '3',
    text: 'Travessa',
  },
  {
    value: '4',
    text: 'Alameda',
  },
  {
    value: '5',
    text: 'Praça',
  },
  {
    value: '6',
    text: 'Rodovia',
  },
  {
    value: '7',
    text: 'Estrada',
  },
  {
    value: '8',
    text: 'Viela',
  },
  {
    value: '9',
    text: 'Largo',
  },
  {
    value: '10',
    text: 'Vila',
  },
]

export const transformTipoEnderecoToOption = (
  lista: { value: string; text: string }[],
  tipoLogradouro: string,
) => {
  const tipoLogradouroSelecionado = lista.find(
    (item) => item.value === tipoLogradouro || item.text === tipoLogradouro,
  )

  if (tipoLogradouroSelecionado) {
    const optionTipoLogradouroSelecionada = {
      value: tipoLogradouroSelecionado.value,
      text: tipoLogradouroSelecionado.text,
    }

    return optionTipoLogradouroSelecionada
  }

  return { value: '', text: '' }
}

export const buildBancosNovo = (bancos: Banco[]) =>
  bancos?.map(({ nome, codigo }) => ({ value: codigo, text: nome }))

export const transformBancoToOption = (lista: Banco[], bancoSelecionado: string) => {
  const bancoSelecionadoNovo = lista.find((item) => item.codigo === bancoSelecionado)

  if (bancoSelecionadoNovo) {
    const optionSelecionada = {
      value: bancoSelecionadoNovo.codigo,
      text: bancoSelecionadoNovo.nome,
    }

    return optionSelecionada
  }
  return { value: '', text: '' }
}

export const TiposContaNovo = [
  {
    value: '1',
    text: 'Conta Corrente',
  },
  {
    value: '2',
    text: 'Conta Poupança',
  },
]

export const transformTipoContaToOption = (
  lista: { value: string; text: string }[],
  tipoContaSelecionado: string,
) => {
  const tipoContaSelecionadoNovo = lista.find(
    (item) =>
      item.value === tipoContaSelecionado ||
      item.text === tipoContaSelecionado ||
      (tipoContaSelecionado === 'CC' && item.value === '1') ||
      (tipoContaSelecionado === 'CP' && item.value === '2'),
  )

  if (tipoContaSelecionadoNovo) {
    const optionSelecionada = {
      value: tipoContaSelecionadoNovo.value,
      text: tipoContaSelecionadoNovo.text,
    }

    return optionSelecionada
  }

  return { value: '', text: '' }
}

export const normalizeTipoConta = (tipoConta: string): string => {
  if (tipoConta === 'CC' || tipoConta === '1' || tipoConta.toLowerCase() === 'conta corrente') {
    return '1'
  }

  if (tipoConta === 'CP' || tipoConta === '2' || tipoConta.toLowerCase() === 'conta poupança') {
    return '2'
  }

  return tipoConta
}
